import React, {Fragment} from "react";
import PropTypes from "prop-types";
import SpinnerDiv from "root/Components/SpinnerDiv";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";

import {
    defaultTableHeaderStyles,
    defaultPaginationOptions,
    customHeaderStyle, defaultTopLeftCellStyle, defaultTopRightCellStyle,
    TableActionIconView
} from "./BaseTableComponents";

import './Table.scss'

const MisuseReportTable = (props) =>
{
    const onClickItem = (misuse_report_id, mode) =>
    {
        props.clickHandler(misuse_report_id, mode);
    }

    const linkFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        return (
            <Fragment>
                <TableActionIconView text="View Report" onClick={() => onClickItem(row.misuse_report_id, 'view')} />
            </Fragment>
        );
    }

    const leftHeaderStyle = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        name: {borderRadius: defaultTopLeftCellStyle, width: "5vw"},
        formatted_date: {width: "2vw"},
        misuse_user_name: {width: "5vw"},
        misuse_description: {width: "20vw"},
        blocked_user_name: {width: "5vw"},
        view: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "6vw"}
    });

    const getColumns = () => {
        const columns = [
            {
                dataField: "name",
                text: "Reported By",
                sort: true,
                headerStyle: leftHeaderStyle
            },
            {
                dataField: "formatted_date",
                text: "Date Reported",
                headerStyle: leftHeaderStyle
            },
            {
                dataField: "misuse_user_name",
                text: "User Reported",
                headerStyle: leftHeaderStyle
            },
            {
                dataField: "misuse_description",
                text: "Description",
                headerStyle: leftHeaderStyle
            },
            {
                dataField: "blocked_user_name",
                text: "User Blocked",
                headerStyle: leftHeaderStyle
            },
            {
                dataField: "view",
                formatter: linkFormatter,
                align: 'right',
                text: "Manage",
                headerStyle: leftHeaderStyle
            },
        ];

        return columns;
    };

    const translations = xlateBootstrapTableColumns(getColumns());
    const columns = React.useMemo(() => translations, []);

    const thisTableContent = () =>
    {
        return <PassportTable data={props.data} columns={columns} pagination={defaultPaginationOptions}/>
    }

    return props.loading === true ? <SpinnerDiv/> : thisTableContent();
    };

export default MisuseReportTable;

MisuseReportTable.propTypes = {
    family_id: PropTypes.string,
    data: PropTypes.array,
    loading: PropTypes.bool
};